import type { WinDivisions } from '../../../../../schema/forecast/entry.js';

/**
 * Calculate the player's win amount based on win divisions and bet amount.
 *
 * @param winDivisions Current win divisions for draw
 * @param betAmount Bet amount for the wager
 * @param winDivisionsRowCount Array of number of rows in each win division
 * @returns Calculated player win amount
 */
export function calculatePlayerWinAmount(
  winDivisions: WinDivisions[],
  betAmount: number,
  winDivisionsRowCount?: number[]
): number {
  let playerWinAmount = 0;

  if (!Array.isArray(winDivisions) || !Array.isArray(winDivisionsRowCount)) {
    return playerWinAmount;
  }

  for (const { winDivision, winValue } of winDivisions) {
    playerWinAmount += (winDivisionsRowCount[winDivision - 1] ?? 0) * winValue * betAmount;
  }

  return playerWinAmount;
}
